import styled from 'styled-components';

const StyledContent = styled.div`
  .identity__prediction-error {
    color: #e02d21;
    margin-left: 12px;
    margin-top: -16px;

    & a {
      font-size: inherit;
    }
  }

  // TODO: This is a workaround to fix margins on Select element from WCL,
  // as the element from the library is not correctly forwarding the className to the child
  .identity__field-select.identity__field > div > div {
    margin: 0;
  }
`;

export default StyledContent;
